import { EMAIL_TEMPLATE_DETAILS,EMAIL_TEMPLATE_DETAILS_SUCCESS, EMAIL_TEMPLATE_DETAILS_FAILED, ADD_EMAIL_TEMPLATE,ADD_EMAIL_TEMPLATE_SUCCESS,ADD_EMAIL_TEMPLATE_FAILED,
    EDIT_EMAIL_TEMPLATE,EDIT_EMAIL_TEMPLATE_SUCCESS,EDIT_EMAIL_TEMPLATE_FAILED,
    GET_DEFAULT_EMAIL_TEMPLATE_DATA,GET_DEFAULT_EMAIL_TEMPLATE_DATA_SUCCESS, GET_DEFAULT_EMAIL_TEMPLATE_DATA_FAIL
} from "./actionTypes"

const initialState = {

    loading: false,
    emailpreviewLoading: false,
    emailtemplateListSuccess: null,
    emailtemplateListFailed: null,
    emailtemplateAddSuccess: null,
    emailtemplateAddFailed: null,
    emailtemplateEditSuccess: null,
    emailtemplateEditFailed: null,
    //new
    emailTemplateData : null,
    emailTemplateDataError: null
}

const emailGetTemplateConfiguration = (state = initialState, action) => {
    switch (action.type) {
        case EMAIL_TEMPLATE_DETAILS: {
            state = {
                ...state,
                loading: true,
                emailtemplateListSuccess: null,
                emailtemplateListFailed: null
            }
            break;

        }
        case EMAIL_TEMPLATE_DETAILS_SUCCESS: {
            state = {
                ...state,
                loading: false,
                emailtemplateListSuccess: action.payload,
                emailtemplateListFailed: null
            }
            break;

        }
        case EMAIL_TEMPLATE_DETAILS_FAILED: {
            state = {
                ...state,
                loading: false,
                emailtemplateListSuccess: null,
                emailtemplateListFailed: action.payload
            }
            break;
        }
        case ADD_EMAIL_TEMPLATE: {
            state = {
                ...state,
                loading: true,
                emailtemplateAddSuccess: null,
                emailtemplateAddFailed: null
            }
            break;

        }
        case ADD_EMAIL_TEMPLATE_SUCCESS: {
            state = {
                ...state,
                loading: false,
                emailtemplateAddSuccess: action.payload,
                emailtemplateAddFailed: null
            }
            break;

        }
        case ADD_EMAIL_TEMPLATE_FAILED: {
            state = {
                ...state,
                loading: false,
                emailtemplateAddSuccess: null,
                emailtemplateAddFailed: action.payload
            }
            break;
        }
        case EDIT_EMAIL_TEMPLATE: {
            state = {
                ...state,
                loading: true,
                emailtemplateEditSuccess: null,
                emailtemplateEditFailed: null
            }
            break;

        }
        case EDIT_EMAIL_TEMPLATE_SUCCESS: {
            state = {
                ...state,
                loading: false,
                emailtemplateEditSuccess: action.payload,
                emailtemplateEditFailed: null
            }
            break;

        }
        case EDIT_EMAIL_TEMPLATE_FAILED: {
            state = {
                ...state,
                loading: false,
                emailtemplateEditSuccess: null,
                emailtemplateEditFailed: action.payload
            }
            break;

        }

        case  GET_DEFAULT_EMAIL_TEMPLATE_DATA: {
            state = {
                ...state,
                // loading: true,
                emailTemplateData: null,
                emailTemplateDataError: null
            }
            break;

        }
        case  GET_DEFAULT_EMAIL_TEMPLATE_DATA_SUCCESS: {
            state = {
                ...state,
                loading: false,
                emailTemplateData: action.payload,
                emailTemplateDataError: null
            }
            break;
        }

        case  GET_DEFAULT_EMAIL_TEMPLATE_DATA_FAIL: {
            state = {
                ...state,
                loading: false,
                emailTemplateData: null,
                emailTemplateDataError:action.payload,
            }
            break;
        }


        // case GET_TEMPLATE: {
        //     state = {
        //         ...state,
        //         loading: true,
        //         detail: null,
        //         detailFailed: null
        //     }
        //     break;

        // }
        // case GET_TEMPLATE_SUCCESS: {
        //     state = {
        //         ...state,
        //         loading: false,
        //         detail: action.payload,
        //         detailFailed: null
        //     }
        //     break;

        // }
        // case GET_TEMPLATE_FAILED: {
        //     state = {
        //         ...state,
        //         loading: false,
        //         detail: null,
        //         detailFailed: action.payload
        //     }
        //     break;
        // }
        // case DELETE_TEMPLATE: {
        //     state = {
        //         ...state,
        //         loading: true,
        //         deleteSuccess: null,
        //         deleteFailed: null,
        //     }
        //     break;

        // }
        // case DELETE_TEMPLATE_SUCCESS: {
        //     state = {
        //         ...state,
        //         loading: false,
        //         deleteSuccess: action.payload,
        //         deleteFailed: null,
        //     }
        //     break;

        // }
        // case DELETE_TEMPLATE_FAILED: {
        //     state = {
        //         ...state,
        //         loading: false,
        //         deleteSuccess: null,
        //         deleteFailed: action.payload,
        //     }
        //     break;
        // }
        // case TEMPLATE_PREVIEW: {
        //     state = {
        //         ...state,
        //         previewLoading: true,
        //         previewSuccess: null,
        //         previewFailed: null,
        //     }
        //     break;

        // }
        // case TEMPLATE_PREVIEW_SUCCESS: {
        //     state = {
        //         ...state,
        //         previewLoading: false,
        //         previewSuccess: action.payload,
        //         previewFailed: null,
        //     }
        //     break;

        // }
        // case TEMPLATE_PREVIEW_FAILED: {
        //     state = {
        //         ...state,
        //         previewLoading: false,
        //         previewSuccess: null,
        //         previewFailed: action.payload,
        //     }
        //     break;
        // }
        // case GET_TEMPLATE_DATA: {
        //     state = {
        //         ...state,
        //         loading: true,
        //         templateData: null,
        //     }
        //     break;
        // }
        // case GET_TEMPLATE_DATA_SUCCESS: {
        //     state = {
        //         ...state,
        //         loading: false,
        //         templateData: action.payload
        //     }
        //     break;
        // }

        // case GET_TEMPLATE_DATA_FAIL: {
        //     state = {
        //         ...state,
        //         loading: false,
        //         templateData: null
        //     }
        //     break;
        // }

        default:
            state = { ...state }
            break
    }
    return state
}

export default emailGetTemplateConfiguration
